class ScrollSliderv2 {
    constructor(name) {
        this.list = document.querySelector(`[data-scroll-slider-lists="${name}"]`)
        if (!this.list) throw new Error(`Selector 'data-scroll-slider-lists="${name}"' not found`)
        this.arrowPrev = document.querySelector(`[data-scroll-slider-prev="${name}"]`)
        if (!this.arrowPrev) throw new Error(`Selector 'data-scroll-slider-prev="${name}"' not found`)
        this.arrowNext = document.querySelector(`[data-scroll-slider-next="${name}"]`)
        if (!this.arrowNext) throw new Error(`Selector 'data-scroll-slider-next="${name}"' not found`)
        this.items = this.list.children
        if (this.items.length === 0) throw new Error('list items must not be empty')
        this.index = 0
        this.timeout = null

        this.init()
    }

    init() {
        this.showHideArrows()
        this.listener()
    }

    showHideArrows() {
        let listWidth = this.list.getBoundingClientRect().width
        let allItemsWidth = 0
        for (let i = 0; i < this.items.length; i++) {
            allItemsWidth += this.items[i].getBoundingClientRect().width
        }
        console.log(listWidth, allItemsWidth)
        if (allItemsWidth > listWidth) {
            this.arrowPrev.style.display = 'block'
            this.arrowNext.style.display = 'block'
        } else {
            this.arrowPrev.style.display = 'none'
            this.arrowNext.style.display = 'none'
        }
    }

    listener() {
        this.arrowPrev.addEventListener('click', e => {
            this.arrowPrevHandleClick()
        })
        this.arrowNext.addEventListener('click', e => {
            this.arrowNextHandleClick()
        })
        this.list.addEventListener('scroll', e => {
            this.listHandleScroll()
        })
        window.addEventListener('resize', this.showHideArrows.bind(this))
    }

    arrowPrevHandleClick() {
        if (this.index > 0) {
            const scrollWidth = this.items[this.index - 1].getBoundingClientRect().width
            this.list.scrollLeft = this.list.scrollLeft - scrollWidth
            this.index--
        }
        if (this.index === 0) {
            this.list.scrollLeft = 0
        }
    }

    arrowNextHandleClick() {
        if (this.index < this.items.length - 1) {
            const scrollWidth = this.items[this.index].getBoundingClientRect().width
            this.list.scrollLeft = this.list.scrollLeft + scrollWidth
            this.index++
        }
    }

    listHandleScroll() {
        clearTimeout(this.timeout)
        let currentItemIndex = null
        let offset = 10000
        this.timeout = setTimeout(() => {
            for (let i = 0; i < this.items.length; i++) {
                let itemOffset = this.list.getBoundingClientRect().left - this.items[i].getBoundingClientRect().left
                let absItemOffset = Math.abs(itemOffset)
                if (offset > absItemOffset) {
                    offset = absItemOffset
                    currentItemIndex = i
                }
            }
            this.index = currentItemIndex
        }, 250)
    }
}

const allScrollSliderOnPage = document.querySelectorAll('[data-scroll-slider-lists]')
for (let i = 0; i < allScrollSliderOnPage.length; i++) {
    const name = allScrollSliderOnPage[i].getAttribute('data-scroll-slider-lists')
    new ScrollSliderv2(name, allScrollSliderOnPage[i])
}
